import {useCallback, useEffect, useState} from 'react';
import {Button, makeStyles, useMediaQuery, useTheme} from '@material-ui/core';
import Projects from './projects';
import CreatorTable from './table';
import CreatorTray from './tray';
import {useDispatch, useSelector} from 'react-redux';
import {getExperiences, getListExperiencesReels, getProjectExperiences, setLoading,} from "../../../../store/actions";
import {
  getProjects,
  initAlertStatus,
  onSendEmailForContactUs
} from "../../../../store/actions/creator/creatorDashboard";
import {
  initExpParticipantData,
  onAddRemoveBenchmarkExperience,
  searchExperience,
  setBenchmarkLoading,
  updatePage,
  updateReelsPage,
  updatesearchfilters
} from "../../../../store/actions/experience/experience";
import CreatorResult from './result';
import UtilService from '../../../../helper/service';
import {Helmet} from "react-helmet";
import {
  getSessionParticipantsSuccess,
  initLiveAnalysisData,
  onSetProjectID,
  onSetTempProject,
  updateProjectFolderId,
} from "../../../../store/actions/creator/creatorExperienceManager";
import {BackDropAnalyzeLoading, Loading} from '../../../atoms/commonLoadings';
import {
  exportExperiencesAsZip,
  initAnalysisData,
  onGetClipInfo,
  removeCliped,
  updateAnalyzeClipedData,
  updateClipedData
} from "../../../../store/actions/creator/analysis";
import {PAGINATION_PER_PAGE_ITEM,} from '../../../../config/mock';
import clsx from 'clsx';
import {useHistory} from "react-router";
import CustomSnackBar from "../experienceManager/participantsDashboard/component/CustomSnackBar";
import roles from "../../../../helper/roles";
import AddToProjectModal from "../../../atoms/modals/addToProjectModal";
import DeleteExperienceModalDotMenu from "../../../atoms/modals/deleteExperienceModalDotMenu";
import CopyExperienceModalDotMenu from "../../../atoms/modals/copyExperienceModalDotMenu";
import DuplicateExperienceModalDotMenu from "../../../atoms/modals/duplicateExperienceModalDotMenu.tsx";
import RenameExperienceModal from "../../../atoms/modals/RenameExperienceModal";
import MobileProjects from "./mobile/mobileProjects";
import MobileCreatorTable from "./mobile/mobileCreatorTable";
import MobileReelTable from "./mobile/mobileReelTable";
import CreatorReelsTable from './reels/reelsTable';
import DeleteClipModal from "../../../atoms/modals/deleteClipModal";
import RenameClipModal from "../../../atoms/modals/RenameClipModal";
import {addComparePath, removeComparePath} from '../../../../store/actions/creator/compare';
import {initLiveParticipantData} from '../../../../store/actions/liveParticipants';
import Config from '../../../../config/config'

const useStyles = makeStyles((theme) => ({
  root: {
    flex: '1 1 auto',
    height: '100%',
    overflowY: 'scroll',
    background: '#F0F0F0',
    paddingTop: theme.spacing(2.5),
    '@media only screen and (max-width: 600px)': {
      paddingLeft: 15,
      paddingRight: 15
    }
  },
  table: {
    marginLeft: 210,
    marginRight: 18,
    paddinTop: 40,
    minWidth: 865
  },
  title: {
    fontFamily: 'roboto-light',
    color: '#606B76',
    fontSize: 20,
    '& span': {
      color: '#017AEF'
    }
  },
  empty: {
    marginLeft: 200,
    marginRight: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '85vh'
  },
  hover: {
    cursor: 'pointer'
  },
  loadMoreBtn: {
    padding: '6px 20px',
    background: '#017AEF',
    marginTop: 0,
    marginBottom: 25,
    color: '#fff',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    textTransform: 'none',
  },
  loadMoreDiv: {
    textAlign: 'center',
    marginBottom: 5
  },
  selected: {
    paddingBottom: 280
  },
  addNewBtn: {
    fontFamily: 'roboto-regular',
    marginLeft: 5,
    marginRight: 5
  },
  btn: {
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    margin: '0 15px',
  },
  onboardingResumeDiv: {
    zIndex: 10000,
    width: (props: any) => props.width < 960 ? '100%' : 'calc(100% - 65px)',
    height: '100%',
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  onboardingResumeTitle: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25
  },
  onboardingResumeDescription: {
    fontFamily: 'roboto-light',
    fontSize: 24,
    color: '#212D40',
    lineHeight: 1.25,
    textAlign: 'center'
  },
  onboardingResumeImg: {
    width: 300,
    height: 'auto',
    margin: '20px 0'
  },
  onboardingResumeBtnLabel: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    marginLeft: 5,
    marginRight: 5
  },
  onboardingResumeBtn: {
    borderRadius: 6,
    padding: '10px 25px 10px 25px',
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    }
  },
  onboardingResumeSmallLabel: {
    marginTop: 50,
    fontFamily: 'roboto-regular',
    fontSize: 12,
    lineHeight: 1.25,
    color: '#212D40'
  },
  onboardingResumeContactLabel: {
    marginTop: 10,
    cursor: 'pointer',
    fontFamily: 'roboto-bold',
    fontSize: 12,
    color: '#017AEF'
  },
  mobileMargin: {
    margin: 0,
    '@media screen and (max-width: 1280px) and (min-width: 600px)': {
      marginTop: 0,
      margin: 12
    },
  }
}));

export default function CreatorDashboard() {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const dashboard_sort_request = localStorage.getItem("dashboard_sort_request") ? JSON.parse(localStorage.getItem("dashboard_sort_request") || "{}") : "";
  const project_sort_request = localStorage.getItem("project_sort_request") ? JSON.parse(localStorage.getItem("project_sort_request") || "{}") : "";
  const reels_sort_request = localStorage.getItem("reels_sort_request") ? JSON.parse(localStorage.getItem("reels_sort_request") || "{}") : "";
  const search_sort_request = localStorage.getItem("search_sort_request") ? JSON.parse(localStorage.getItem("search_sort_request") || "{}") : "";
  const dashboard_pagination = localStorage.getItem("dashboard_pagination") ? JSON.parse(localStorage.getItem("dashboard_pagination") || "{}") : "";
  const reels_pagination = localStorage.getItem("reels_pagination") ? JSON.parse(localStorage.getItem("reels_pagination") || "{}") : "";

  const {
    experience, sessions, projectSessions, searchKey, searchText, searchUsers, searchfilters, listLoading, is_loading,
    totalExperience, userColumn, page, reels, reel_sessions, totalReelExperience,
    reels_filter_direction, benchmarkLoading
  } = useSelector((state: any) => state.experience);
  const reels_page = (reels_pagination.page_no ? reels_pagination.page_no : 1);


  const { specialProjectId, fetching, projectID, tempProject } = useSelector((state: any) => state.creatorExperienceManager);
  const { fetchingScores } = useSelector((state: any) => state.analysis);
  const { experienceAddedMsg, isExperienceAdded } = useSelector((state: any) => state.creatorDashboard);
  const apolloClient = useSelector((state: any) => state.apolloClient);

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const onboardingFinished = localStorage.getItem('onboardingFinished') ? localStorage.getItem('onboardingFinished') : '';
  const selectedProjectId = localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null;

  const [selected, setSelected] = useState<any>([]);
  const [reelsFilterDirection, setReelsFilterDirection] = useState(reels_filter_direction);
  const [filterDirection, setFilterDirection] = useState(false)
  const [sortDirection, setSortDirection] = useState('')
  const [sortColumn, setSortColumn] = useState('')
  // state variable to handle alert for adding experiences to project
  const [snackAlertType, setSnackAlertType] = useState('');
  const [snackAlertMsg, setSnackMsg] = useState('');
  const [showSnackAlert, setShowSnackAlert] = useState(false);
  const [showAddToProjectModal, setShowAddToProjectModal] = useState(false);
  const [selectedExperienceData, setExperieceData] = useState(null);
  const [selectedClip, setSelectedClip] = useState(null);
  const [showUserCol, setshowUserCol] = useState("");
  const [islistLoading, setislistLoading] = useState(true);
  const [openReelData, setOpenReelData] = useState<any>([])
  const [openReelId, setOpenReelId] = useState(-1);
  const [reelsData, setReelsData] = useState<any>([]);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [showDeleteClipModal, setShowDeleteClipModal] = useState(false);
  const [showRenameClipModal, setShowRenameClipModal] = useState(false);
  const [isSearchpage, setIsSearchpage] = useState(false);
  const [isOnboarding, setIsOnboarding] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const [showConfirmAlert, setShowConfirmAlert] = useState(false);
  const [exporting, setExporting] = useState<boolean>(false);
  const [clipSelectLoading, setClipSelectLoading] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  useEffect(() => {
    if (!onboardingFinished && loginUserData && loginUserData.creator_on_board) {
      setIsOnboarding(true);
    }
  }, [onboardingFinished, loginUserData]);

  useEffect(() => {
    if (searchKey) {
      setshowUserCol(searchKey.show_user_column);
    }
  }, [searchKey]);

  useEffect(() => {
    if (searchfilters && searchfilters === 'clear') {
      localStorage.removeItem('search_sort_request');
      dispatch(updatesearchfilters(''));
    }
  }, [searchfilters]);

  useEffect(() => {
    if (!listLoading) {
      setTimeout(() => {
        setislistLoading(false);
      }, 7000);
    }
  }, [listLoading]);

  const getProjectExperiencesList = () => {
    const projectId: any = localStorage.getItem("projectId");
    if ((projectId) && parseFloat(projectId) != -1 && parseFloat(projectId) != -2) {
      const proreq = {
        sort_direction: project_sort_request.sort_direction,
        sort_column: project_sort_request.sort_column,
        project_id: parseFloat(projectId),
      };
      dispatch(getProjectExperiences(apolloClient.client, proreq, null));
    }
  }
  
  // on page load calling project experience list if we are on any project page.
  useEffect(() => {
    dispatch(removeCliped());
    dispatch(removeComparePath());

    getProjectExperiencesList();
    
    dispatch(updateAnalyzeClipedData([]))

    if (dashboard_pagination && dashboard_pagination.page_no) {
      dispatch(updatePage(dashboard_pagination.page_no))
    }
  }, [])

  /* temp commenting for IMM-4661 */
  // useEffect(() => {
  //   function reloadThumbnails() {
  //     let notReadySessions: any = [];
  //     const notreadyIds: any = [];
  //     notReadySessions = sessions.filter((val: any) => val.stimulus_status !== "READY");
  //     notReadySessions.map((ids: any) => {
  //       const found = notreadyIds.some((ele: any) => ele.session_code === ids.session_code);
  //       if (!found) {
  //         notreadyIds.push({
  //           session_id: ids.session_id,
  //           session_code: ids.session_code
  //         });
  //       }
  //     });

  //     dispatch(checkStimulusStatus(apolloClient.client, { session_data: notreadyIds }, null));
  //   }
  //   const interval = setInterval(() => reloadThumbnails(), AUTO_REFERESH_TIME_PARTICIPANT)
  //   return () => {
  //     clearInterval(interval);
  //   }
  // }, [sessions]);


  useEffect(() => {
    if (!fetching) {
      dispatch(initLiveAnalysisData());
      dispatch(initExpParticipantData());
      dispatch(initLiveParticipantData());
    }
  }, [fetching]);

  useEffect(() => {
    if (!fetchingScores) {
      dispatch(initAnalysisData());
    }
  }, [fetchingScores]);

  useEffect(() => {
    if (!specialProjectId) return;
    dispatch(onSetProjectID(specialProjectId));
  }, [specialProjectId])

  useEffect(() => {
    if (!!loginUserData && loginUserData.user_id) {
      const request1 = { projectOwnerId: Number(loginUserData.user_id) };
      dispatch(getProjects(apolloClient.client, request1));
    }
  }, [apolloClient.client, dispatch, loginUserData.user_id]);

  useEffect(() => {
    let sort_column_temp = "";
    let sort_direction_temp = "";

    if (projectID === -1) {
      sort_column_temp = dashboard_sort_request.sort_column;
      sort_direction_temp = dashboard_sort_request.sort_direction;
      const request = {
        user_id: loginUserData.user_id,
        page_no: 1,
        size: PAGINATION_PER_PAGE_ITEM * (dashboard_pagination.page_no ? dashboard_pagination.page_no : page),
        firstpage: true,
        sort_direction: sort_direction_temp,
        sort_column: sort_column_temp
      };
      dispatch(getExperiences(apolloClient.client, request, null));
    }

    if (loginUserData && loginUserData.role_access) {
      if (loginUserData.role_access.length) {
        const batch_async = loginUserData.role_access.filter((val: any) => val.access_name === "batch_async");
        if (batch_async.length > 0 && batch_async[0].access_value) {
          sort_column_temp = reels_sort_request.sort_column;
          sort_direction_temp = reels_sort_request.sort_direction;

          const request = {
            user_id: loginUserData.user_id,
            page_no: 1,
            size: PAGINATION_PER_PAGE_ITEM * (reels_pagination.page_no ? reels_pagination.page_no : reels_page),
            firstpage: true,
            sort_direction: sort_direction_temp ? sort_direction_temp : "",
            sort_column: sort_column_temp ? sort_column_temp : ""
          };
          dispatch(getListExperiencesReels(apolloClient.client, request));
        }
      }
    }
  }, [projectID, apolloClient.client, dispatch, loginUserData.user_id,]);

  useEffect(() => {
    if (selectedProjectId) {
      dispatch(onSetProjectID(Number(selectedProjectId)));
    }
    if (!selectedProjectId) {
      dispatch(onSetProjectID(-1));
    }
    const getVideoThumbNamils = async () => {
      // when back to here from top bar for specific folder
      if (selectedProjectId) {
        dispatch(onSetProjectID(Number(selectedProjectId)));
      }
    };
    experience && getVideoThumbNamils();
  }, [dispatch, experience, selectedProjectId]);

  useEffect(() => {
    if (experienceAddedMsg) {
      isExperienceAdded === true ? setSnackAlertType('success') : setSnackAlertType('warning');
      setSnackMsg(experienceAddedMsg);
      setShowSnackAlert(true);
      dispatch(onSetTempProject(false));
      clearAll();
      setTimeout(()=>{
        getProjectExperiencesList();
      }, 5000)
    }
  }, [isExperienceAdded, experienceAddedMsg]);

  useEffect(() => {
    if (reels) {
      setReelsData(reels);
    }
  }, [reels]);

  useEffect(() => {
    if (reel_sessions && openReelId) {
      if (reel_sessions.items && reel_sessions.items.sessions) {
        setOpenReelData(reel_sessions.items.sessions);
      }
    }
  }, [reel_sessions, openReelId]);

  // on open reels subtable
  const onOpenReelsSessions = async (current_reel: any, sessionIds: any) => {
    setOpenReelId(current_reel);
    const session_ids: any[] = [];
    sessionIds && sessionIds.length &&
      sessionIds.map((id: any) => {
        if (session_ids.indexOf(String(id)) == -1) {
          session_ids.push(String(id));
        }
      });

    const request = {
      reels_sessions: true,
      user_id: loginUserData.user_id,
      page_no: 1,
      size: PAGINATION_PER_PAGE_ITEM * page,
      firstpage: true,
      sort_direction: sortDirection,
      sort_column: sortColumn,
      session_ids: session_ids,
    };
    dispatch(getExperiences(apolloClient.client, request, null));
  }

  const isClipped = (session: any) => {
    if (!session) return false;

    return (String(session.session_id).includes('clip-'));
  }

  const goToCompare = () => {

    if (!selected || selected.length < 1) return;

    const item = { ...selected[0] };

    dispatch(initAnalysisData());
    dispatch(initLiveAnalysisData());
    if (!item.session_code) return;
    dispatch(getSessionParticipantsSuccess(null));
    localStorage.setItem("session_code", String(item.session_code));
    localStorage.setItem("session_id", String(item.session_id));
    localStorage.setItem("session_name", String(item.name));

    const routertabname = "compare";
    let url = `/creator/experience-manager/${routertabname}/${item.session_code}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/${routertabname}/${item.session_code}`;
    }
    history.push(url, { data: [...selected], session_id: item.session_id });

    setSelected([]);

    if (isClipped(item)) {
      setTimeout(() => {
        dispatch(addComparePath('dashboard'));
        dispatch(updateClipedData({
          title: item.name,
          start_clip: item.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(item.start, false) / 15 : item.start,
          end_clip: item.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(item.end, true) / 15 : item.end,
          clip_id: item.clip_id,
          session_code: item.session_code,
          score: {
            immersion: {
              immersion_index: item.immersion,
              tier_indicator: item.immersion_tier_indicator,
              color_indicator: item.immersion_color_indicator,
              context_indicator: item.immersion_context_indicator,
            },
            safety: {
              safety_index: item.safety,
              tier_indicator: item.safety_tier_indicator,
              color_indicator: item.safety_color_indicator,
              context_indicator: item.safety_context_indicator,
            }
          }
        }))
      }, 1000);
    }
  };

  const onCompare = () => {
    goToCompare();
  };

  const onExport = useCallback(() => {
    const selectedSessions = selected.filter((s: any) => {
      if (s && !s.hasOwnProperty('clip_id')) {
        return s
      }
    });
    const selectedClips = selected.filter((s: any) => {
      if (s && s.hasOwnProperty('clip_id')) {
        return s
      }
    });

    const nonCompletedSessions = selectedSessions.filter((session: any) => session.status !== 'COMPLETED');
    const nonCompletedClips = selectedClips.filter((clip: any) => clip.session_status !== 'COMPLETED');

    if (nonCompletedSessions.length > 0 || nonCompletedClips.length > 0) {
      onShowWaitMsg();
    } else {
      setExporting(true);
      let request = {};
      if (selectedSessions.length > 0 && selectedClips.length > 0) {
        const session_codes = selectedSessions.map((session: any) => session.session_code);
        const clips = UtilService.getClipsRequest(selectedClips);

        request = {
          session_codes,
          clips
        }
      } else if (selectedSessions.length > 0 && selectedClips.length === 0) {
        const session_codes = selectedSessions.map((session: any) => session.session_code);
        request = {
          session_codes
        }
      } else if (selectedSessions.length === 0 && selectedClips.length > 0) {
        const clips = UtilService.getClipsRequest(selectedClips);
        request = {
          clips
        }
      }

      dispatch(exportExperiencesAsZip(loginUserData.customer_id, request, (res: any) => {
        if (res) {
          downloadExperienceData(res);
        } else {
          onShowExportErrorMsg();
        }
      }))
    }
  }, [selected]);

  const downloadExperienceData = (export_url: string) => {
    const a = document.createElement('a');
    a.href = export_url;
    a.download = 'download.xlsx';
    a.click();
    setExporting(false);
    clearAll();
  };

  const onShowWaitMsg = () => {
    setSnackAlertType('error');
    setShowSnackAlert(true);
    setSnackMsg('We’re sorry but you can’t export data for experiences that are upcoming or in progress. Please wait until your experience is complete. We will email you with the results so you will know when to come back to download the data.');
  };

  const onShowExportErrorMsg = () => {
    setExporting(false);
    setSnackAlertType('error');
    setShowSnackAlert(true);
    setSnackMsg('Experience exporting is failed.');
  };

  const clearAll = () => {
    setSelected([])
  };

  const onFilterDirection = (e: any) => {
    let result = 'status';
    let sort_column = '';

    if (e === 1) { result = 'name'; sort_column = 'session_title_key' }
    if (e === 2) { result = 'id' }
    if (e === 3) { result = 'type' }
    if (e === 4) { result = 'survey' }
    if (e === 5) { result = 'clips' }
    if (e === 6) { result = 'imm'; sort_column = "immersion_index" }
    if (e === 7) { result = 'sfty'; sort_column = "safety_index" }
    if (e === 8) { result = 'status'; sort_column = "session_status" }
    if (e === 9) { result = 'start'; sort_column = "sort_start" }
    if (e === 10) { result = 'end'; sort_column = "sort_end" }
    if (e === 11) { result = 'participants' }
    if (e === 12) { result = 'owner' }

    if (e === 1 || e === 6 || e === 7 || e === 8 || e === 9 || e === 10) {
      dispatch(setLoading(true));
      setSortColumn(sort_column);

      if (searchKey && searchKey !== 'empty') {
        const req = {
          sort_direction: filterDirection ? "asc" : "desc",
          sort_column: sort_column,
          keyword: searchText,
          user_id: searchUsers,
          page_no: 1,
          size: PAGINATION_PER_PAGE_ITEM * page,
          identifier: 'session',
          clip_page_no: 1,
          clip_page_size: PAGINATION_PER_PAGE_ITEM * page
        };
        setSortDirection(filterDirection ? "asc" : "desc");
        dispatch(searchExperience(apolloClient.client, req));

        const save_search_sort_request = {
          filter_direction: !filterDirection,
          filter_name: result,
          sort_column: sort_column,
          sort_direction: filterDirection ? "asc" : "desc"
        };
        localStorage.setItem('search_sort_request', JSON.stringify(save_search_sort_request));
      } else if (projectID !== -1 && projectID !== -2 && !tempProject) {
        const req = {
          sort_direction: filterDirection ? "asc" : "desc",
          sort_column: sort_column,
          project_id: projectID
        };
        setSortDirection(filterDirection ? "asc" : "desc");
        dispatch(getProjectExperiences(apolloClient.client, req, null));
        const save_project_sort_request = {
          filter_direction: !filterDirection,
          filter_name: result,
          sort_column: sort_column,
          sort_direction: filterDirection ? "asc" : "desc"
        };
        localStorage.setItem('project_sort_request', JSON.stringify(save_project_sort_request));
      } else {
        const req = {
          user_id: loginUserData.user_id,
          page_no: 1,
          size: PAGINATION_PER_PAGE_ITEM * page,
          firstpage: true,
          sort_direction: filterDirection ? "asc" : "desc",
          sort_column: sort_column
        };
        setSortDirection(filterDirection ? "asc" : "desc");
        dispatch(getExperiences(apolloClient.client, req, null));
        const save_dashboard_sort_request = {
          filter_direction: !filterDirection,
          filter_name: result,
          sort_column: sort_column,
          sort_direction: filterDirection ? "asc" : "desc"
        };
        localStorage.setItem('dashboard_sort_request', JSON.stringify(save_dashboard_sort_request));
      }
    }
    setFilterDirection(!filterDirection)
  };

  const onReelsFilterDirection = (e: any) => {
    let result = 'name';
    let sort_column = '';
    if (e === 1) { result = 'name'; sort_column = 'session_title_key' }
    if (e === 2) { result = 'id' }
    if (e === 3) { result = 'survey' }
    if (e === 4) { result = 'experiences in reel' }
    if (e === 5) { result = 'status'; sort_column = "session_status" }
    if (e === 6) { result = 'start'; sort_column = "sort_start" }
    if (e === 7) { result = 'end'; sort_column = "sort_end" }
    if (e === 8) { result = 'participants' }

    if (e === 1 || e === 5 || e === 6 || e === 7) {
      dispatch(setLoading(true));
      setSortColumn(sort_column);
      const req = {
        user_id: loginUserData.user_id,
        page_no: 1,
        size: PAGINATION_PER_PAGE_ITEM * reels_page,
        firstpage: true,
        sort_direction: reelsFilterDirection ? "asc" : "desc",
        sort_column: sort_column

      };
      setSortDirection(reelsFilterDirection ? "asc" : "desc")
      dispatch(getListExperiencesReels(apolloClient.client, req));
    }
    const save_reels_sort_request = {
      reels_filter_direction: !reelsFilterDirection,
      reels_filter: result,
      sort_column: sort_column,
      sort_direction: reelsFilterDirection ? "asc" : "desc",
    };
    localStorage.setItem('reels_sort_request', JSON.stringify(save_reels_sort_request));
    setReelsFilterDirection(!reelsFilterDirection)
  };

  const nextPageData = () => {
    if (projectID === -2) {
      if (page < Math.ceil(totalReelExperience / PAGINATION_PER_PAGE_ITEM)) {
        const request = {
          user_id: loginUserData.user_id,
          page_no: (reels_pagination.page_no ? reels_pagination.page_no : reels_page) + 1,
          size: PAGINATION_PER_PAGE_ITEM,
          sort_direction: sortDirection,
          sort_column: sortColumn
        };
        localStorage.setItem('reels_pagination', JSON.stringify(request));

        dispatch(getListExperiencesReels(apolloClient.client, request));
        dispatch(updateReelsPage((reels_pagination.page_no ? reels_pagination.page_no : reels_page) + 1))
      }
    } else {
      if (page < Math.ceil(totalExperience / PAGINATION_PER_PAGE_ITEM)) {
        const request = {
          user_id: loginUserData.user_id,
          page_no: (dashboard_pagination.page_no ? dashboard_pagination.page_no : page) + 1,
          size: PAGINATION_PER_PAGE_ITEM,
          sort_direction: sortDirection,
          sort_column: sortColumn
        };
        localStorage.setItem('dashboard_pagination', JSON.stringify(request));

        dispatch(getExperiences(apolloClient.client, request, null));
        dispatch(updatePage((dashboard_pagination.page_no ? dashboard_pagination.page_no : page) + 1))
      }
    }
  };

  const hideSnackAlert = () => {
    dispatch(initAlertStatus());
    setShowSnackAlert(false);
  };

  const onClickSelectProject = (e: number) => {
    dispatch(onSetProjectID(e));
    dispatch(updateProjectFolderId(e));
    if (e !== -1) { // in case of excluding "All Experiences"
      let request = {};
      if ((e !== -1 && e !== -2) || (e === -2)) {
        request = {
          sort_direction: project_sort_request.sort_direction ? project_sort_request.sort_direction : "",
          sort_column: project_sort_request.sort_column ? project_sort_request.sort_column : "",
          project_id: e,
        };
      }
      dispatch(getProjectExperiences(apolloClient.client, request, null));
    }
    localStorage.setItem("projectId", String(e));
    dispatch(onSetTempProject(false));
  };

  const goto = () => {
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
    let url = '/creator/experience-builder';
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['builder'])) {
        url = '/subscriber/creator/experience-builder';
      }
    }
    history.push(url);
  };

  const gotoCopyExperience = () => {
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
    let url = '/creator/experience-builder';
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['builder'])) {
        url = '/subscriber/creator/experience-builder';
      }
    }
    dispatch(setLoading(false));
    history.push(url);
  };

  const onAddRemvoeProject = (e: any) => {
    setExperieceData(e);
    handleAddToProjectModal()
  };

  const onSaveBenchmark = (session: any) => {
    dispatch(setBenchmarkLoading(true));
    const request = {
      session_id: session.session_id,
      department_id: Number(loginUserData.department_id),
      star: true,
      user_id: Number(loginUserData.user_id),
      sessions: [String(session.session_id)]
    };
    dispatch(onAddRemoveBenchmarkExperience(apolloClient.client, request))
  };

  const onRemoveBenchmark = (session: any) => {
    dispatch(setBenchmarkLoading(true));
    const request = {
      session_id: session.session_id,
      department_id: Number(loginUserData.department_id),
      star: false,
      user_id: Number(loginUserData.user_id),
      sessions: [String(session.session_id)]
    };
    dispatch(onAddRemoveBenchmarkExperience(apolloClient.client, request))
  };

  const handleAddToProjectModal = () => {
    setShowAddToProjectModal(!showAddToProjectModal);
  };

  const closeAddToProjectModal = () => {
    setExperieceData(null);
    setShowAddToProjectModal(!showAddToProjectModal);
  };

  const deleteExperiece = (e: any) => {
    setExperieceData(e);
    handleDeleteModal()
  };

  const copyExperience = (e: any) => {
    setExperieceData(e);
    handleCopyModal();
  };

  const handleCopyModal = () => {
    setShowCopyModal(!showCopyModal);
  };

  const closeCopyModal = () => {
    setExperieceData(null);
    setShowCopyModal(!showCopyModal);
  };
  const duplicateExperience = (e: any) => {
    setExperieceData(e);
    handleDuplicateModal();
  };

  const handleDuplicateModal = () => {
    setShowDuplicateModal(!showDuplicateModal);
  };

  const closeDuplicateModal = () => {
    setExperieceData(null);
    setShowDuplicateModal(!showDuplicateModal);
  };

  const closeDeleteModal = () => {
    setExperieceData(null);
    setShowDeleteModal(!showDeleteModal);
  };

  const handleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const renameExperiece = (e: any) => {
    setExperieceData(e);
    handleRenameModal()
  };

  const handleRenameModal = () => {
    setShowRenameModal(!showRenameModal);
  };

  const closeRenameModal = () => {
    setExperieceData(null);
    setShowRenameModal(!showRenameModal);
  };

  const deleteClip = (clip: any, issearch = false) => {
    setSelectedClip(clip);
    setShowDeleteClipModal(true);
    setIsSearchpage(issearch);
  };

  const handleRenameClip = (clip: any, issearch = false) => {
    setSelectedClip(clip);
    setShowRenameClipModal(true);
    setIsSearchpage(issearch);
  };

  const closeDeleteClipModal = () => {
    setSelectedClip(null);
    setShowDeleteClipModal(false);
  };

  const closeRenameClipModal = () => {
    setSelectedClip(null);
    setShowRenameClipModal(false);
  };

  const onResumeOnboarding = () => {
    let url = '/creator/onboarding';
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['onboarding'])) {
      url = '/subscriber/creator/onboarding'
    }
    history.push(url);
  };

  const onContactUs = () => {
    setContactLoading(true);
    const request = {
      email: Config.SUPPORT_EMAIL,
      user_email: loginUserData.username
    };
    dispatch(onSendEmailForContactUs(apolloClient.client, request, (res: boolean) => {
      if (res) {
        setShowConfirmAlert(true);
        setContactLoading(false);
      } else {
        setContactLoading(false);
      }
    }))
  };

  const onSelectItem = (array: any[], i: any) => {
    if (String(i.session_id).includes('clip-')) {
      const params = {
        tenant_id: loginUserData.customer_id,
        clip_id: i.clip_id,
        session_code: i.session_code
      };
      dispatch(onGetClipInfo(params, (res: any) => {
        if (res && res.data?.category_breakup) {
          const breakup = res.data?.category_breakup;
          const immersion_detail = {
            Captivated: breakup.immersion_breakup[0].category_percent,
            Absorbed: breakup.immersion_breakup[1].category_percent,
            Interested: breakup.immersion_breakup[2].category_percent,
            Indifferent: breakup.immersion_breakup[3].category_percent,
            "Tuned Out": breakup.immersion_breakup[4].category_percent,
          };

          const safety_detail = {
            Zen: breakup.safety_breakup[0].category_percent,
            'Very Safe': breakup.safety_breakup[1].category_percent,
            Safe: breakup.safety_breakup[2].category_percent,
            Unsafe: breakup.safety_breakup[3].category_percent,
            'Very Unsafe': breakup.safety_breakup[4].category_percent,
          };
          array.push({ ...i, immersion_detail, safety_detail });
          setSelected([...array]);
        }
      }));
    } else if (!i?.immersion_detail && i.immersion_breakup) {
      const immersion_detail: any = {
        'Captivated': 0,
        'Absorbed': 0,
        'Interested': 0,
        'Indifferent': 0,
        'Tuned Out': 0
      };

      const immersionBreakup: [] = i.immersion_breakup ? i.immersion_breakup : [];
      for (let i = 0; i < immersionBreakup.length; i++) {
        const item: any = immersionBreakup[i];
        immersion_detail[item['context_indicator']] = Number(item['category_percent']);
      }

      const safety_detail: any = {
        'Zen': 0,
        'Very Safe': 0,
        'Safe': 0,
        'Unsafe': 0,
        'Very Unsafe': 0
      };

      const safetyBreakup: [] = i.safety_breakup ? i.safety_breakup : [];
      for (let i = 0; i < safetyBreakup.length; i++) {
        const item: any = safetyBreakup[i];
        safety_detail[item['context_indicator']] = Number(item['category_percent']);
      }
      array.push({
        ...i,
        immersion_detail,
        safety_detail,
        name: i.session_title,
        immersion: Number(i.immersion_index),
        safety: Number(i.safety_index),
        img: i.small_thumbnail ? i.small_thumbnail : '/assets/images/video-processing.png',
        img_large: i.large_thumbnail ? i.large_thumbnail : '/assets/images/video-processing.png',
        status: i.session_status,
      });
      setSelected([...array]);
    } else {
      const immersion_detail: any = {
        'Captivated': 0,
        'Absorbed': 0,
        'Interested': 0,
        'Indifferent': 0,
        'Tuned Out': 0
      };
      const safety_detail: any = {
        'Zen': 0,
        'Very Safe': 0,
        'Safe': 0,
        'Unsafe': 0,
        'Very Unsafe': 0
      };
      array.push({
        ...i,
        immersion_detail: i.immersion_detail || immersion_detail,
        safety_detail: i.safety_detail || safety_detail,
        name: i.name || i.session_title,
        immersion: i.immersion || Number(i.immersion_index),
        safety: i.safety || Number(i.safety_index),
        img: i.img || i.small_thumbnail || '/assets/images/video-processing.png',
        img_large: i.img_large || i.large_thumbnail || '/assets/images/video-processing.png',
        status: i.status || i.session_status,
      });
      setSelected([...array]);
    }
  };

  const onChangeSelected = useCallback((i: any) => {
    const array: any = [...selected];

    if ((selected.findIndex((item: any) => item.session_id === i.session_id)) !== -1) {
      array.splice(array.findIndex((item: any) => item.session_id === i.session_id), 1);
      setSelected([...array]);
    } else {
      onSelectItem(array, i);
    }
  }, [selected]);

  const onSelectAllSearchedExperiences = useCallback((searchedExperiences: any[]) => {
    const array = [...selected];
    searchedExperiences.map(async (i: any) => {
      if (array.findIndex((item: any) => item.session_id === i.session_id) === -1) {
        if (!i?.immersion_detail && i.immersion_breakup) {
          const immersion_detail: any = {
            'Captivated': 0,
            'Absorbed': 0,
            'Interested': 0,
            'Indifferent': 0,
            'Tuned Out': 0
          };

          const immersionBreakup: [] = i.immersion_breakup ? i.immersion_breakup : [];
          for (let i = 0; i < immersionBreakup.length; i++) {
            const item: any = immersionBreakup[i];
            immersion_detail[item['context_indicator']] = Number(item['category_percent']);
          }

          const safety_detail: any = {
            'Zen': 0,
            'Very Safe': 0,
            'Safe': 0,
            'Unsafe': 0,
            'Very Unsafe': 0
          };

          const safetyBreakup: [] = i.safety_breakup ? i.safety_breakup : [];
          for (let i = 0; i < safetyBreakup.length; i++) {
            const item: any = safetyBreakup[i];
            safety_detail[item['context_indicator']] = Number(item['category_percent']);
          }
          array.push({
            ...i,
            immersion_detail,
            safety_detail,
            name: i.session_title,
            immersion: Number(i.immersion_index),
            safety: Number(i.safety_index),
            img: i.small_thumbnail ? i.small_thumbnail : '/assets/images/video-processing.png',
            img_large: i.large_thumbnail ? i.large_thumbnail : '/assets/images/video-processing.png',
            status: i.session_status,
          });
        } else {
          array.push(i);
        }
      }
    });
    setSelected([...array]);
  }, [selected]);

  const onSelectAllSearchedClips = useCallback(async (searchedClips: any[]) => {
    setClipSelectLoading(true);

    const array = [...selected];
    const promise = searchedClips.map(async (i: any) => {
      if (array.findIndex((item: any) => item.session_id === i.session_id) === -1) {
        const params = {
          tenant_id: loginUserData.customer_id,
          clip_id: i.clip_id,
          session_code: i.session_code
        };
        await dispatch(onGetClipInfo(params, (res: any) => {
          if (res && res.data?.category_breakup) {
            const breakup = res.data?.category_breakup;
            const immersion_detail = {
              Captivated: breakup.immersion_breakup[0].category_percent,
              Absorbed: breakup.immersion_breakup[1].category_percent,
              Interested: breakup.immersion_breakup[2].category_percent,
              Indifferent: breakup.immersion_breakup[3].category_percent,
              "Tuned Out": breakup.immersion_breakup[4].category_percent,
            };

            const safety_detail = {
              Zen: breakup.safety_breakup[0].category_percent,
              'Very Safe': breakup.safety_breakup[1].category_percent,
              Safe: breakup.safety_breakup[2].category_percent,
              Unsafe: breakup.safety_breakup[3].category_percent,
              'Very Unsafe': breakup.safety_breakup[4].category_percent,
            };
            array.push({ ...i, immersion_detail, safety_detail });
          }
        }));
      }
    });
    await Promise.all(promise);

    setSelected([...array]);
    setClipSelectLoading(false);
  }, [selected]);

  const onClearExperiences = useCallback((experiences: any[]) => {
    onClearSelectedItems(experiences);
  }, [selected]);

  const onClearClips = useCallback((clips: any[]) => {
    onClearSelectedItems(clips);
  }, [selected]);

  const onClearSelectedItems = useCallback((list: any[]) => {
    const array: any = [...selected];
    list.map((i: any) => {
      const index = array.findIndex((item: any) => item.session_id === i.session_id);
      if (index !== -1) {
        array.splice(index, 1);
      }
    });
    setSelected([...array]);
  }, [selected]);

  return (
    <div className={classes.root}>
      <Helmet title="Creator" />
      {isOnboarding && (
        <div className={classes.onboardingResumeDiv}>
          <BackDropAnalyzeLoading loading={contactLoading} />
          <div className={classes.onboardingResumeTitle}>
            Welcome to your Experience Dashboard
          </div>
          <div className={classes.onboardingResumeDescription}>
            Before you start measuring Immersion on your own content or experiences,<br />
            you’ll need to first complete onboarding. It only takes a few minutes.
          </div>
          <img
            className={classes.onboardingResumeImg}
            src={'/assets/icons/creatordashboard/onboarding-resume.svg'}
            alt={'Resume Onboarding'}
          />
          <Button
            color='primary'
            className={classes.onboardingResumeBtn}
            onClick={onResumeOnboarding}
          >
            <span className={classes.onboardingResumeBtnLabel}>Resume Onboarding</span>
          </Button>
          <div className={classes.onboardingResumeSmallLabel}>
            Don’t see what you’re looking for?
          </div>
          <div className={classes.onboardingResumeContactLabel} onClick={onContactUs}>
            Contact Us
          </div>
          <CustomSnackBar
            type={'success'}
            message={'Thank you we have emailed support.'}
            open={showConfirmAlert}
            onClose={() => setShowConfirmAlert(false)}
          />
        </div>
      )}
      <RenameExperienceModal
        open={showRenameModal}
        onClose={closeRenameModal}
        experienceData={selectedExperienceData}
      />
      <DeleteExperienceModalDotMenu
        open={showDeleteModal}
        onClose={closeDeleteModal}
        experienceData={selectedExperienceData}
      />
      <CopyExperienceModalDotMenu
        open={showCopyModal}
        onClose={closeCopyModal}
        gotoCopyExperience={gotoCopyExperience}
        experienceData={selectedExperienceData}
      />
      <DuplicateExperienceModalDotMenu
        open={showDuplicateModal}
        onClose={closeDuplicateModal}
        gotoCopyExperience={gotoCopyExperience}
        experienceData={selectedExperienceData}
      />
      <AddToProjectModal
        open={showAddToProjectModal}
        onClose={closeAddToProjectModal}
        selected={selected}
        type={"dropMenu"}
        experienceData={selectedExperienceData}
      />
      <DeleteClipModal
        issearchpage={isSearchpage}
        selectedClip={selectedClip}
        open={showDeleteClipModal}
        onCloseDeleteModal={closeDeleteClipModal}
      />
      <RenameClipModal
        issearchpage={isSearchpage}
        selectedClip={selectedClip}
        open={showRenameClipModal}
        onClose={closeRenameClipModal}
      />
      <BackDropAnalyzeLoading loading={benchmarkLoading || exporting || clipSelectLoading} />
      {(!searchKey && isMobile) ? (
        <div className={classes.mobileMargin}>
          <MobileProjects
            onSelectProject={(e: number) => onClickSelectProject(e)}
            reelsLength={reels.length}
          />
          <MobileCreatorTable
            sessions={
              (projectSessions && projectID != -1) ?
                projectSessions
                :
                sessions
            }
          />
          {sessions && sessions.length > 0 && Math.ceil(totalExperience / PAGINATION_PER_PAGE_ITEM) !== page && projectID === -1 && (
            <div className={classes.loadMoreDiv}>
              {!is_loading && <Button className={classes.loadMoreBtn} onClick={nextPageData}>
                Load more...
              </Button>}
              {is_loading && <Loading />}
            </div>
          )}


          {projectID === -2 &&
            <MobileReelTable
              reelsSessions={(reelsData && reelsData.length > 0) ? reelsData : []}
            />
          }
          {reelsData && reelsData.length > 0 && Math.ceil(totalReelExperience / PAGINATION_PER_PAGE_ITEM) !== page && projectID === -2 && (
            <div className={classes.loadMoreDiv}>
              {!is_loading && <Button className={classes.loadMoreBtn} onClick={nextPageData}>
                Load more...
              </Button>}
              {is_loading && <Loading />}
            </div>
          )}
        </div>
      ) : (
        <div className={classes.mobileMargin}>
          {!searchKey && (
            <>
              <Projects
                onSelectProject={(e: number) => onClickSelectProject(e)}
                projectId={projectID}
                reelsLength={reels.length}
              />
              {(is_loading || islistLoading) && sessions.length === 0 && <Loading />}

              <div className={clsx(classes.table, ((UtilService.filterByProject(sessions, projectID)).length > 0 && selected.length > 0 && classes.selected))}>
                { projectID !== -2 &&
                  <>
                    <CreatorTable
                      sessions={
                        (projectSessions && projectID != -1 && !tempProject) ? projectSessions : sessions
                      }
                      userColumn={userColumn}
                      selected={selected}
                      filter={projectID == -1 || tempProject ? dashboard_sort_request.filter_name : project_sort_request.filter_name}
                      disableNavigation={false}
                      onChangeSelected={(i: any) => onChangeSelected(i)}
                      onClickFilter={(e: any) => onFilterDirection(e)}
                      filterDirection={projectID == -1 || tempProject ? dashboard_sort_request.filter_direction : project_sort_request.filter_direction}
                      onAddRemvoeProject={(e: any) => onAddRemvoeProject(e)}
                      deleteExperiece={(e: any) => deleteExperiece(e)}
                      renameExperiece={(e: any) => renameExperiece(e)}
                      copyExperience={(e: any) => copyExperience(e)}
                      duplicateExperience={(e: any) => duplicateExperience(e)}
                      deleteClip={(clip: any) => deleteClip(clip)}
                      onRenameClip={(clip: any) => handleRenameClip(clip)}
                      onSaveBenchmark={(session: any) => onSaveBenchmark(session)}
                      onRemoveBenchmark={(session: any) => onRemoveBenchmark(session)}
                    />
                    {sessions && sessions.length > 0 && Math.ceil(totalExperience / PAGINATION_PER_PAGE_ITEM) !== page && (projectID === -1 || tempProject) && (
                      <div className={classes.loadMoreDiv}>
                        {!is_loading && <Button className={classes.loadMoreBtn} onClick={nextPageData}>
                          Load more...
                        </Button>}
                        {is_loading && <Loading />}
                      </div>
                    )}
                  </>
                }
                {
                  projectID === -2 &&
                  <>
                    <CreatorReelsTable
                      reelsSessions={(reelsData && reelsData.length > 0) ? reelsData : []}
                      selected={selected}
                      filter={reels_sort_request.reels_filter ? reels_sort_request.reels_filter : ""}
                      disableNavigation={false}
                      onChangeSelected={(i: any) => onChangeSelected(i)}
                      onOpenReelsSessions={(current_reel: any, sessionIds: any) => onOpenReelsSessions(current_reel, sessionIds)}
                      openReelData={openReelData}
                      openReelId={openReelId}
                      onClickFilter={(e: any) => onReelsFilterDirection(e)}
                      deleteExperiece={(e: any) => deleteExperiece(e)}
                      renameExperiece={(e: any) => renameExperiece(e)}
                      onSaveBenchmark={(session: any) => onSaveBenchmark(session)}
                      onRemoveBenchmark={(session: any) => onRemoveBenchmark(session)}
                      filterDirection={reels_sort_request.reels_filter_direction ? reels_sort_request.reels_filter_direction : ""}
                    />
                  </>
                }
                {reelsData && reelsData.length > 0 && Math.ceil(totalReelExperience / PAGINATION_PER_PAGE_ITEM) !== reels_page && projectID === -2 && (
                  <div className={classes.loadMoreDiv}>
                    {!is_loading && <Button className={classes.loadMoreBtn} onClick={nextPageData}>
                      Load more...
                    </Button>}
                    {is_loading && <Loading />}

                  </div>
                )}
              </div>

              {
                (!islistLoading && projectID === -1 && (!sessions || sessions.length === 0)) &&
                <div className={classes.empty}>
                  <div className={classes.title}>
                    When you use Immersion to measure experiences you create,
                  </div>
                  <div className={classes.title} style={{ paddingTop: 10, paddingBottom: 30 }}>
                    you’ll see them in your dashboard here.
                  </div>
                  <img src={'/assets/icons/creatordashboard/no-experience.svg'} alt={'img'} />
                  <div className={classes.title} style={{ padding: '30px 0' }}>
                    Let’s get you started and measure your first experience:
                  </div>
                  <Button
                    color='primary'
                    id='mne_button'
                    className={classes.btn}
                    onClick={goto}
                  >
                    <img src={'/assets/icons/creatordashboard/plus_icon.svg'} alt={'img'} />
                    <span className={classes.addNewBtn}>Measure New Experience</span>
                  </Button>
                </div>
              }
            </>
          )}
          {selected.length > 0 && (
            <CreatorTray
              sessions={UtilService.filterByProject(sessions, projectID)}
              hideAddToProject={false}
              selected={selected}
              clearAll={clearAll}
              onRemove={(e: any) => onChangeSelected(e)}
              onCompare={() => onCompare()}
              onExport={() => onExport()}
            />)
          }
          {searchKey && searchKey !== 'empty' && (
            <CreatorResult
              sessions={searchKey.sessions}
              selected={selected}
              userColumn={showUserCol}
              filter={search_sort_request.filter_name}
              disableNavigation={false}
              onChangeSelected={(i: any) => onChangeSelected(i)}
              onClickFilter={(e: any) => onFilterDirection(e)}
              filterDirection={search_sort_request.filter_direction}
              onAddRemvoeProject={(e: any) => onAddRemvoeProject(e)}
              deleteExperiece={(e: any) => deleteExperiece(e)}
              renameExperiece={(e: any) => renameExperiece(e)}
              copyExperience={(e: any) => copyExperience(e)}
              duplicateExperience={(e: any) => duplicateExperience(e)}
              onSaveBenchmark={(session: any) => onSaveBenchmark(session)}
              onRemoveBenchmark={(session: any) => onRemoveBenchmark(session)}
              deleteClip={(clip: any, issearch: any) => deleteClip(clip, issearch)}
              onRenameClip={(clip: any, issearch: any) => handleRenameClip(clip, issearch)}
              onSelectAllExperiences={onSelectAllSearchedExperiences}
              onClearExperiences={onClearExperiences}
              onSelectAllClips={onSelectAllSearchedClips}
              onClearClips={onClearClips}
            />
          )}
        </div>
      )}
      {
        (projectSessions.length === 0 && projectID !== -1 && projectID !== -2 && !tempProject) &&
        <>
          <div className={classes.empty}>
            <img src={'/assets/icons/creatordashboard/empty_screen.svg'} alt={'img'} />
            <p className={classes.title}>
              There are no items in this project…
              <span className={classes.hover} onClick={() => {dispatch(onSetTempProject(true));}}>let’s find some.</span>
            </p>
          </div>
        </>}
      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={showSnackAlert} onClose={hideSnackAlert} />
    </div>
  );
}
